import { useState } from 'react';

import { useResizeObserver } from './useResizeObserver';

export const useMeasureWidth = <T extends HTMLElement = HTMLElement>() => {
  const [width, setWidth] = useState<number>(0);

  const [ref] = useResizeObserver<T>({
    onResize: (rect) => {
      if (rect.width !== width) {
        setWidth(rect.width);
      }
    },
  });

  return [ref, { width }] as const;
};
